// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2TT8C","unreadBadge":"styles_unreadBadge__3n5rd","modalContent":"styles_modalContent__25I2j","modal":"styles_modal__2AFzZ"};